<template>
    <div class="box">
        <form @submit.prevent="bannerSubmit">
            <b-field
                label="Home Page Banner Image URL"
                grouped
                :message="bannerForm.errors.get('banner_image')"
                :type="{ 'is-danger': bannerForm.errors.has('banner_image') }"
            >
                <b-input v-model="bannerForm.banner_image" expanded />
                <b-button type="is-primary" native-type="submit">Save</b-button>
            </b-field>
        </form>
    </div>
</template>

<script>
import vForm from "../../../plugins/vForm";
export default {
    data() {
        return {
            bannerForm: new vForm({ banner_image: null }),
        };
    },
    mounted() {
        this.$http.get("/home/banner").then(({ data }) => (this.bannerForm.banner_image = data.banner_image));
    },
    methods: {
        bannerSubmit() {
            this.bannerForm
                .submit("post", "/home/banner")
                .then(() => this.notify("Changed successfully.", "is-success"))
                .catch((e) => this.notify(e.getMessage(), "is-danger"));
        },
    },
};
</script>

<style>
</style>